import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import superagent from 'superagent'

import {backendUrl} from '../../helpers/consts.js'
import { replaceWithErrorStatus } from './replaceWithErrorStatus';
import { requestErrorMessage } from './requestErrorMessage';

const makeid = (length) => {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const getRequestID = () => {
  return makeid(16)
}

/**
 * GET `url` and track it. Returns `[data, state, errorMessage]`: `errorMessage` is the
 * server's own explanation of a failed request (a 400's reason, say), for pages that
 * show it instead of loading forever; undefined otherwise.
 */
const useQuery = ({ url, queryData, refresh, runQuery = true }) => {
  const history = useHistory();
  const [apiData, setApiData] = useState();
  const [state, setState] = useState('loading');
  const [errorMessage, setErrorMessage] = useState();

  // The request whose answer the page shows. An older one answering late must not
  // overwrite it, whether that answer is a success or an error.
  const latestRequestID = useRef()

  
  const paramsData = queryData
    ? Object.entries(queryData)
      .filter(([, value]) => value !== undefined && value !== null && value !== '')
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    : [];
  const params = paramsData.length > 0 ? `?${paramsData.join('&')}` : '';
  useEffect(() => {
    if (!runQuery) return;

    const newReqID = getRequestID()
    latestRequestID.current = newReqID
    const isLatest = () => latestRequestID.current === newReqID
    setState('loading')
    setErrorMessage(undefined)

    let preUrl = `${backendUrl}${url}${params}`
    if (url?.includes('https://')) {
      preUrl = url
    }

    superagent.get(`${preUrl}`)
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
      .set('accept', 'json')
      .on('error', (response) => {
        if (!isLatest()) return
        const code = response.status
        setState('error')
        setErrorMessage(requestErrorMessage(response))
        replaceWithErrorStatus(history, code);
      })
      .then(response => {
        if (!isLatest()) return
        const code = response.status
        if (code > 400) {
          replaceWithErrorStatus(history, code);
        } else {
          setState('success')
          setApiData(response.body);
        }
      }).catch(err => {
        if (!isLatest()) return
        setState('error')
        console.log(err)
      });
  }, [url, history, params, refresh, runQuery]);

  return [apiData, state, errorMessage];
};

export default useQuery;
